import Hero from "../components/Hero/Hero"


function Home() {

    return (
        <>
            <Hero />
        </>
    )
}

export default Home